import React from "react"
import type { GatsbyBrowser } from "../@alexandrudanpop/byfolio-theme/src/compat/gatsby-public-api"
import AnalyticsConsent from "./src/analytics/analytics-consent"
import {
  initializeAnalyticsConsent,
  recordAnalyticsRoute,
} from "./src/analytics/runtime"
import "./src/css/fonts.css"

export const onClientEntry: NonNullable<
  GatsbyBrowser["onClientEntry"]
> = () => {
  initializeAnalyticsConsent()
}

export const onRouteUpdate: NonNullable<GatsbyBrowser["onRouteUpdate"]> = ({
  location,
}) => {
  recordAnalyticsRoute(location)
}

export const wrapPageElement: NonNullable<GatsbyBrowser["wrapPageElement"]> = ({
  element,
}) => React.createElement(AnalyticsConsent, null, element)
